import React from 'react';
import PropTypes from 'prop-types';

import {Route, Redirect} from 'react-router-dom';

const allowedMerchantRoutes = [
    '/merchantDetails',
    '/openingHours',
    '/item',
];

export const PrivateRoute = ({
    isAutenticated,
    userRole,
    merchantId,
    component:Component,
    ...rest
}) => {

    return (
        <Route {...rest}
            component={(props)=> {
                if (!isAutenticated) {
                    return <Redirect to="/auth/login"/>;
                }
                if (userRole === 'merchant') {
                    const currentPath = props.location.pathname;
                    const parts = currentPath.split('/');
                    const id = Number(parts[2]);
                    const isAllowed = allowedMerchantRoutes.some(path =>
                        currentPath.startsWith(path)
                    );
                    // redirigir si no está en su ruta 
                    if ( id !== merchantId ) { //si el usuario mete un id que no es su negocio
                        return <Redirect to={`/merchantDetails/${merchantId}`}/>;
                    }
                    if (!isAllowed) { //si intenta por algun otro url
                        return <Redirect to={`/merchantDetails/${merchantId}`}/>;
                    }
                }
                return <Component {...props}/>;
            }}
        />
    )
}


PrivateRoute.propTypes = {
    isAutenticated:PropTypes.bool.isRequired,
    component:PropTypes.func.isRequired,
    userRole: PropTypes.string,
    merchantId: PropTypes.number
}
